import { ThemeColorsKeys } from '@agria/theme/src/styles/tokens/colors';

export type LinkTokens = {
  circleBorderColor: ThemeColorsKeys;
  circleHoverBorderColor: ThemeColorsKeys;
  circleHoverBackgroundColor: ThemeColorsKeys;
  hoverColour: ThemeColorsKeys;
};

const tokens: LinkTokens = {
  circleBorderColor: 'brandTwo100',
  circleHoverBorderColor: 'brandTwo100',
  circleHoverBackgroundColor: 'utilityWhite',
  hoverColour: 'brandTwo100',
} as const;

export default tokens;
